import { render } from "./InvestasiDetailPerusahaan.vue?vue&type=template&id=52a578dc"
import script from "./InvestasiDetailPerusahaan.vue?vue&type=script&lang=js"
export * from "./InvestasiDetailPerusahaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__